const DSN_LIST_RETURN_STATE_KEY = 'dsn-list-return-state';

export interface DsnListReturnState {
  selectedRowId: string;
  scrollY: number;
  currentPage: number;
  pageSize: number;
}

const isDsnListReturnState = (value: unknown): value is DsnListReturnState => {
  if (!value || typeof value !== 'object') return false;

  const state = value as Partial<DsnListReturnState>;
  return (
    typeof state.selectedRowId === 'string' &&
    state.selectedRowId.length > 0 &&
    typeof state.scrollY === 'number' &&
    Number.isFinite(state.scrollY) &&
    state.scrollY >= 0 &&
    typeof state.currentPage === 'number' &&
    Number.isInteger(state.currentPage) &&
    state.currentPage > 0 &&
    typeof state.pageSize === 'number' &&
    Number.isInteger(state.pageSize) &&
    state.pageSize > 0
  );
};

export const saveDsnListReturnState = (
  selectedRowId: string,
  currentPage: number,
  pageSize: number,
): void => {
  try {
    const state: DsnListReturnState = {
      selectedRowId,
      scrollY: Math.max(0, window.scrollY),
      currentPage,
      pageSize,
    };

    sessionStorage.setItem(DSN_LIST_RETURN_STATE_KEY, JSON.stringify(state));
  } catch {
    // Storage can be unavailable (for example in private browsing). Navigation must still work.
  }
};

export const readDsnListReturnState = (): DsnListReturnState | null => {
  try {
    const storedState = sessionStorage.getItem(DSN_LIST_RETURN_STATE_KEY);
    if (!storedState) return null;

    const parsedState: unknown = JSON.parse(storedState);
    if (isDsnListReturnState(parsedState)) return parsedState;

    sessionStorage.removeItem(DSN_LIST_RETURN_STATE_KEY);
  } catch {
    // Treat unreadable or unavailable storage as an absent return state.
  }

  return null;
};

export const clearDsnListReturnState = (): void => {
  try {
    sessionStorage.removeItem(DSN_LIST_RETURN_STATE_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
};
